import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface RecruitingGoalsSectionProps {
  goals: {
    tech: number;
    gtm: number;
    gna: number;
    exec: number;
  };
  onChange: (field: "tech" | "gtm" | "gna" | "exec") => (value: number) => void;
  isCalculated?: boolean;
}

export const RecruitingGoalsSection = ({
  goals,
  onChange,
  isCalculated = false,
}: RecruitingGoalsSectionProps) => {
  const handleInputChange = (field: "tech" | "gtm" | "gna" | "exec") => (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    // Allow any decimal input including empty string
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      const numericValue = value === '' ? 0 : Number(value);
      if (!isNaN(numericValue)) {
        console.log(`Monthly recruiting goal for ${field} changed to:`, numericValue);
        onChange(field)(numericValue);
      }
    }
  };

  // Format value for display - return empty string for 0 only in display
  const formatDisplayValue = (value: number) => 
    value === 0 && !String(value).length ? '' : String(value);

  return (
    <div className="space-y-4 mt-4">
      <h4 className="font-semibold text-md">Recruiter Hiring Goals (hires/month)</h4>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="space-y-2">
          <Label htmlFor="techGoal">Tech & Product</Label>
          <Input
            id="techGoal"
            type="number"
            step="0.1"
            min="0"
            value={formatDisplayValue(goals.tech)}
            onChange={handleInputChange("tech")}
            placeholder="Monthly goal"
            readOnly={isCalculated}
            className={isCalculated ? "bg-gray-100" : ""}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="gtmGoal">Go-to-market</Label>
          <Input
            id="gtmGoal"
            type="number"
            step="0.1"
            min="0"
            value={formatDisplayValue(goals.gtm)}
            onChange={handleInputChange("gtm")}
            placeholder="Monthly goal"
            readOnly={isCalculated}
            className={isCalculated ? "bg-gray-100" : ""}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="gnaGoal">G&A</Label>
          <Input
            id="gnaGoal"
            type="number"
            step="0.1"
            min="0"
            value={formatDisplayValue(goals.gna)}
            onChange={handleInputChange("gna")}
            placeholder="Monthly goal"
            readOnly={isCalculated}
            className={isCalculated ? "bg-gray-100" : ""}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="execGoal">Executive</Label>
          <Input
            id="execGoal"
            type="number"
            step="0.1"
            min="0"
            value={formatDisplayValue(goals.exec)}
            onChange={handleInputChange("exec")}
            placeholder="Monthly goal"
            readOnly={isCalculated}
            className={isCalculated ? "bg-gray-100" : ""}
          />
        </div>
      </div>
    </div>
  );
};